module.exports = __webpack_public_path__ + "static/og_image-021d8041147e02b8d60ea50431ead138.png";